import "core-js/modules/es.array.push.js";
import test from "./test.vue";
import "@/assets/fonts/font.css";
import axios from "axios";
import moment from "moment";
import global from "./components/global";
import CryptoJS from "crypto-js";
import { pinyin } from "pinyin";


import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
/** 耗时日志仅当超过该毫秒数才输出（与 home / courseArrange 一致） */
const SLOW_STEP_LOG_MS = 500;
export default {
  components: {
    test
  },
  data() {
    return {
      zoom: 1,
      institution: "",
      username: "",
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      title: "首页",
      routePath: "",
      showModifyPassword: false,
      formerPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      // 待处理金额异动的学生数
      pendingDealStudentIds: [],
      // 申请试用记录
      showApplyTestRecords: false,
      applyTestRecords: [],
      // 只有特定手机号，才展示申请试用记录按钮
      showApplyTestRecordsButton: false,
      // 待继续排课的班级
      classList: [],
      oriClassList: [],
      classNames: {},
      needArrangeCourseClassIds: [],
      // 菜单栏相关
      // 记录当前是第几个菜单被选中
      menuIndex: sessionStorage.getItem("menuIndex") ? sessionStorage.getItem("menuIndex") : 1,
      titles: ["首页", "当日考勤", "排课调课", "报名与课消", "财务", "课时统计", "人员设置"],
      paths: ["/home", "/checkIn", "/", "/", "/", "/courseStatistics", "/peopleManagement"],
      menu3SubIndex: sessionStorage.getItem("menu3SubIndex") ? sessionStorage.getItem("menu3SubIndex") : 0,
      // menu3SubTitles: [
      //   "校区与教室",
      //   "老师与授课科目",
      //   "收费单价",
      //   "老师假期管理",
      //   "排课调课",
      //   "发布课程",
      //   "排课日志",
      // ],
      menu3SubTitles: ["校区与教室", "老师与授课科目", "收费单价", "老师假期管理", "排课调课", "排课日志"],
      // menu3Paths: [
      //   "campus",
      //   "teacherAndCourse",
      //   "teacherFee",
      //   "vacation",
      //   "courseArrange",
      //   "publishCourse",
      //   "operationLog",
      // ],
      menu3Paths: ["campus", "teacherAndCourse", "teacherFee", "vacation", "courseArrange", "operationLog"],
      menu4SubIndex: sessionStorage.getItem("menu4SubIndex") ? sessionStorage.getItem("menu4SubIndex") : 0,
      menu4SubTitles: ["报名", "学员管理", "交易记录"],
      menu4Paths: ["enrollment", "studentManagement", "paymentRecords"],
      menu5SubIndex: sessionStorage.getItem("menu5SubIndex") ? sessionStorage.getItem("menu5SubIndex") : 0,
      // menu5SubTitles: ["财务看板", "提现", "退费审核", "顾问业绩"],
      menu5SubTitles: ["财务看板", "退费审核", "顾问业绩"],
      // menu5Paths: [
      //   "financialDashboard",
      //   "withdraw",
      //   "refundApproval",
      //   "consultantPerformance",
      // ],
      menu5Paths: ["financialDashboard", "refundApproval", "consultantPerformance"],
      pendingRefundApplyList: [],
      pendingRefundApplyNumber: 0,
      pendingCheckInDate: [],
      tipResolver: null,
      showTip: false,
      tipMessage: "",
      tipNeedInput: false,
      tipInputText: ""
    };
  },
  async mounted() {
    this.autoResize();

    // 初始没登录，没有值
    this.institution = sessionStorage.getItem("institution");
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (this.userInfo) {
      this.username = this.userInfo.name;
    }

    // 初始没有值，执行不了的，放到updateVariable里面了
    if (this.institution) {
      await this.getRefundApprovalList();
      await this.getPendingCheckIn();
    }
  },
  // 监听路由变化 (APP.vue中，mounted, created中还获取不到路由)
  // 访问哪个路由，目录对应的菜单项高亮
  watch: {
    $route: {
      handler(to, from) {
        // console.log("路由变化:", from, "->", to);

        if (!from) {
          return;
        }
        if (!to.name) {
          return;
        }

        // 每次切换路由，更新变量
        if (this.userInfo) {
          // this.updateVariable();

          if (this.institution == "得森") {
            this.updateVariable();
          }
        }
        this.routePath = to.name;
        console.log("this.routePath:", this.routePath);

        // 哪个菜单
        if (this.paths.indexOf(this.routePath) !== -1) {
          this.menuIndex = this.paths.indexOf(this.routePath) + 1;
        }
        // 哪个子菜单
        else {
          if (this.menu3Paths.indexOf(this.routePath) !== -1) {
            this.menuIndex = 3;
            this.menu3SubIndex = this.menu3Paths.indexOf(this.routePath) + 1;
          }
          if (this.menu4Paths.indexOf(this.routePath) !== -1) {
            this.menuIndex = 4;
            this.menu4SubIndex = this.menu4Paths.indexOf(this.routePath) + 1;
          }
          if (this.menu5Paths.indexOf(this.routePath) !== -1) {
            this.menuIndex = 5;
            this.menu5SubIndex = this.menu5Paths.indexOf(this.routePath) + 1;
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    autoResize() {
      //页面自适应
      let wid = window.innerWidth;
      let hei = window.innerHeight;
      // console.log("innerWidth:", wid);
      // console.log("innerHeight:", hei);
      // console.log(document.documentElement.scrollWidth);
      if (hei / 1080 < wid / 1920) {
        console.log("hei");
        this.zoom = hei / 1080;
        document.getElementById("app").style.zoom = this.zoom;
      } else {
        this.zoom = wid / 1920;
        document.getElementById("app").style.zoom = this.zoom;
      }
      document.getElementById("app").style.marginLeft = (wid / this.zoom - 1920) / 2 + "px";
      document.getElementById("app").style.marginTop = (hei / this.zoom - 1080) / 2 + "px";
      sessionStorage.setItem("zoom", this.zoom);

      // 窗口变化时调整尺寸
      window.onresize = () => {
        console.log("window resize");
        let wid = window.innerWidth;
        let hei = window.innerHeight;
        // console.log("innerWidth:", wid);
        // console.log("innerHeight:", hei);
        // console.log(document.documentElement.scrollWidth);
        if (hei / 1080 < wid / 1920) {
          console.log("hei");
          this.zoom = hei / 1080;
          document.getElementById("app").style.zoom = this.zoom;
        } else {
          this.zoom = wid / 1920;
          document.getElementById("app").style.zoom = this.zoom;
        }
        document.getElementById("app").style.marginLeft = (wid / this.zoom - 1920) / 2 + "px";
        document.getElementById("app").style.marginTop = (hei / this.zoom - 1080) / 2 + "px";
        sessionStorage.setItem("zoom", this.zoom);

        //刷新页面
        // location.reload();
      };
    },
    // 更新变量
    async updateVariable() {
      console.log("updateVariable function start");
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      if (this.userInfo) {
        this.username = this.userInfo.name;
      }
      this.institution = sessionStorage.getItem("institution");
      if (this.userInfo) {
        // 姓名首字母
        this.userInfo.nameFirstLetter = pinyin(this.userInfo.name, {
          style: pinyin.STYLE_FIRST_LETTER
        })[0][0];
        // 如果是英文, 取第一个字母
        if (this.userInfo.nameFirstLetter.length > 1) {
          this.userInfo.nameFirstLetter = this.userInfo.nameFirstLetter.substring(0, 1);
        }
        // 转大写字母
        this.userInfo.nameFirstLetter = this.userInfo.nameFirstLetter.toUpperCase();

        /////////////////
        // 几个红色圈的数字
        if (this.institution) {
          const tAll = Date.now();
          {
            const t0 = Date.now();
            await this.getRefundApprovalList();
            const dtRefund = Date.now() - t0;
            if (dtRefund > SLOW_STEP_LOG_MS) {
              console.log(`[App.vue] getRefundApprovalList took ${dtRefund}ms (>${SLOW_STEP_LOG_MS}ms)`);
            }
          }
          {
            const t0 = Date.now();
            await this.getPendingCheckIn();
            const dtCheckIn = Date.now() - t0;
            if (dtCheckIn > SLOW_STEP_LOG_MS) {
              console.log(`[App.vue] getPendingCheckIn took ${dtCheckIn}ms (>${SLOW_STEP_LOG_MS}ms)`);
            }
          }
          {
            const t0 = Date.now();
            // 用时较长，不await
            // await this.getStudentChangeFeePendingDealNum();
            this.getStudentChangeFeePendingDealNum();
            const dtFeePending = Date.now() - t0;
            if (dtFeePending > SLOW_STEP_LOG_MS) {
              console.log(`[App.vue] getStudentChangeFeePendingDealNum took ${dtFeePending}ms (>${SLOW_STEP_LOG_MS}ms)`);
            }
          }
          {
            const t0 = Date.now();
            // 用时较长，不await
            // await this.getNeedArrangeCourseClassNum();
            this.getNeedArrangeCourseClassNum();
            const dtArrangeNum = Date.now() - t0;
            if (dtArrangeNum > SLOW_STEP_LOG_MS) {
              console.log(`[App.vue] getNeedArrangeCourseClassNum took ${dtArrangeNum}ms (>${SLOW_STEP_LOG_MS}ms)`);
            }
          }
          const dtRedDotsAll = Date.now() - tAll;
          if (dtRedDotsAll > SLOW_STEP_LOG_MS) {
            console.log(`[App.vue] 几个红色圈的数字 total took ${dtRedDotsAll}ms (>${SLOW_STEP_LOG_MS}ms)`);
          }
        }
      }

      // 只有特定手机号，才展示申请试用记录按钮
      let phones = ["13187654321", "13510664590"];
      if (this.userInfo) {
        if (phones.includes(this.userInfo.phone)) {
          this.showApplyTestRecordsButton = true;
        } else {
          this.showApplyTestRecordsButton = false;
        }
      } else {
        this.showApplyTestRecordsButton = false;
      }
      console.log("updateVariable function end");
    },
    // 修改密码
    modifyPassword() {
      this.showModifyPassword = true;
    },
    async modifyPasswordConfirm() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (this.formerPassword == "" || this.newPassword == "" || this.confirmNewPassword == "") {
          alert("请填写所有输入框");
          return;
        }
        if (this.newPassword !== this.confirmNewPassword) {
          alert("两次输入的新密码不一致");
          return;
        }

        // 原密码加密
        let encryptedPassword = CryptoJS.AES.encrypt(this.formerPassword, global.keyArray.join("") // 将数组转换为字符串作为密钥
        ).toString();

        // 新密码加密
        let newEncryptedPassword = CryptoJS.AES.encrypt(this.newPassword, global.keyArray.join("") // 将数组转换为字符串作为密钥
        ).toString();

        // 更新密码
        let params = {
          formerPassword: encryptedPassword,
          phone: this.userInfo.phone,
          password: newEncryptedPassword
        };
        let resp1 = await axios.post("https://backend.wonology.com/login/modifyPassword", params);
        if (resp1.data.code == "0000") {
          this.$message({
            message: "修改密码成功",
            type: "success"
          });
          this.showModifyPassword = false;
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    modifyPasswordCancel() {
      this.showModifyPassword = false;
    },
    //菜单栏相关
    async clickMenu(index) {
      // 如果点击本身, 不做响应
      if (this.menuIndex == index) {
        // 点击本身，收起菜单
        this.menuIndex = "";
        return;
      }
      this.menuIndex = index;
      this.title = this.titles[index - 1];
      let path = this.paths[index - 1];

      //点击menu3，默认显示子菜单第一项
      if (index == 3) {
        // 如果没有内容，默认显示第一项
        if (this.menu3SubIndex == 0) {
          this.menu3SubIndex = 1;
          this.title = this.menu3SubTitles[0];
          path = this.menu3Paths[0];
        }
        // 如果已有内容，显示之前选择的项
        else {
          this.title = this.menu3SubTitles[this.menu3SubIndex - 1];
          path = this.menu3Paths[this.menu3SubIndex - 1];
        }
      }
      //点击menu4，默认显示子菜单第一项
      else if (index == 4) {
        // 如果没有内容，默认显示第一项
        if (this.menu4SubIndex == 0) {
          this.menu4SubIndex = 1;
          this.title = this.menu4SubTitles[0];
          path = this.menu4Paths[0];
        }
        // 如果已有内容，显示之前选择的项
        else {
          this.title = this.menu4SubTitles[this.menu4SubIndex - 1];
          path = this.menu4Paths[this.menu4SubIndex - 1];
        }
      }
      //点击menu5，默认显示子菜单第一项
      else if (index == 5) {
        await this.getRefundApprovalList();

        // 如果没有内容，默认显示第一项
        if (this.menu5SubIndex == 0) {
          this.menu5SubIndex = 1;
          path = this.menu5Paths[0];
          this.title = this.menu5SubTitles[0];
        }
        // 如果已有内容，显示之前选择的项
        else {
          this.title = this.menu5SubTitles[this.menu5SubIndex - 1];
          path = this.menu5Paths[this.menu5SubIndex - 1];
        }
      }
      // 点击其他的menu
      else {
        //子menu被清空

        this.menu3SubIndex = 0;
        this.menu4SubIndex = 0;
        this.menu5SubIndex = 0;
      }

      //跳转到对应页面
      this.$router.push({
        path: path
      });
      sessionStorage.setItem("menuIndex", index);
      sessionStorage.setItem("menu3SubIndex", this.menu3SubIndex);
      sessionStorage.setItem("menu4SubIndex", this.menu4SubIndex);
      sessionStorage.setItem("menu5SubIndex", this.menu5SubIndex);
    },
    clickSubMenu(index, subIndex) {
      let path = "";
      if (index == 3) {
        this.menu3SubIndex = subIndex;
        this.title = this.menu3SubTitles[subIndex - 1];
        path = this.menu3Paths[subIndex - 1];
      }
      if (index == 4) {
        this.menu4SubIndex = subIndex;
        this.title = this.menu4SubTitles[subIndex - 1];
        path = this.menu4Paths[subIndex - 1];
      }
      if (index == 5) {
        this.menu5SubIndex = subIndex;
        this.title = this.menu5SubTitles[subIndex - 1];
        path = this.menu5Paths[subIndex - 1];
      }

      //跳转到对应页面
      this.$router.push({
        path: path
      });
      sessionStorage.setItem("menuIndex", index);
      sessionStorage.setItem("menu3SubIndex", this.menu3SubIndex);
      sessionStorage.setItem("menu4SubIndex", this.menu4SubIndex);
      sessionStorage.setItem("menu5SubIndex", this.menu5SubIndex);
    },
    async logout() {
      this.showTip = true;
      this.tipMessage = "确认退出登录？";
      // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
      // 后面通过 this.tipResolver(value) 返回值
      const tipConfirmed = await new Promise(resolve => {
        this.tipResolver = resolve;
      });
      if (tipConfirmed === "confirm") {
        // 用户选择确认，继续执行

        this.showTip = false;
        // 重置变量
        this.tipMessage = "";
        this.tipNeedInput = false;
      } else {
        // 用户选择取消，返回

        return;
      }
      sessionStorage.removeItem("institution");
      sessionStorage.removeItem("userInfo");

      //清空sessionStorage
      sessionStorage.clear();
      this.$router.push({
        path: "/login"
      });
    },
    // 获取待处理考勤的日期
    async getPendingCheckIn() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/checkIn/getPendingCheckIn", params);
        if (resp1.data.code == "0000") {
          this.pendingCheckInDate = resp1.data.data;
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 获取退费申请 待审批列表
    async getRefundApprovalList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getPendingRefundApply", params);
        if (resp1.data.code == "0000") {
          this.pendingRefundApplyList = resp1.data.data;

          // 计算待审批数量
          this.pendingRefundApplyNumber = 0;
          for (let i in this.pendingRefundApplyList) {
            if (this.pendingRefundApplyList[i].status == 1) {
              this.pendingRefundApplyNumber += 1;
            }
          }

          // 格式化时间
          for (let i in this.pendingRefundApplyList) {
            this.pendingRefundApplyList[i].create_time = moment(this.pendingRefundApplyList[i].create_time).format("YYYY-MM-DD HH:mm:ss");
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 审批退费申请, 更新退费审批的数字
    async refundApproval() {
      await this.getRefundApprovalList();
    },
    // 获取待处理金额异动的学生数
    async getStudentChangeFeePendingDealNum() {
      //loading界面
      // const loading = ElLoading.service({
      //   lock: true,
      //   text: "处理中...",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });

      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getStudentChangeFeePendingDealNum", params);
        if (resp1.data.code == "0000") {
          this.pendingDealStudentIds = resp1.data.data;

          // console.log("this.pendingDealStudentIds:", this.pendingDealStudentIds);
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        // loading.close();
      }
    },
    // 获取有多少班级的已排课时 还没达到设置的总课时
    async getNeedArrangeCourseClassNum() {
      // 获取班级列表，已排课时
      await this.getClassList();
      // await this.getClassList(true);

      this.needArrangeCourseClassIds = [];
      for (let i in this.classList) {
        // 如果结班，跳过
        if (this.classList[i].endDate < moment().format("YYYY-MM-DD")) {
          continue;
        }
        if (this.classList[i].arrangedHour < this.classList[i].totalHour) {
          this.needArrangeCourseClassIds.push(this.classList[i].id);
        }
        if (this.classList[i].arrangedHour > this.classList[i].totalHour) {
          this.needArrangeCourseClassIds.push(this.classList[i].id);
        }
      }
    },
    // 获取班级列表，已排课时
    async getClassList(needCalculateArrangedHour, classId) {
      //loading界面
      // const loading = ElLoading.service({
      //   lock: true,
      //   text: "处理中...",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });

      try {
        let params = {
          institution: this.institution,
          needCalculateArrangedHour: needCalculateArrangedHour,
          classId: classId
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getClassList", params);
        if (resp1.data.code == "0000") {
          this.classList = resp1.data.data;

          // 部分字段json.parse()
          for (let i in this.classList) {
            this.classList[i].teacherIds = JSON.parse(this.classList[i].teacherIds);
            // 将 teacherId 倒序排列
            this.classList[i].teacherIds.sort((a, b) => b - a);
            this.classList[i].courses = JSON.parse(this.classList[i].courses);
            this.classList[i].periods = JSON.parse(this.classList[i].periods);
          }
          this.oriClassList = JSON.parse(JSON.stringify(this.classList));

          // console.log("获取班级列表 this.classList:", this.classList);

          // classId转换为className
          for (let i = 0; i < this.classList.length; i++) {
            this.classNames[this.classList[i].id] = this.classList[i].name;
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        // loading.close();
      }
    },
    // 提示弹窗 取消
    closeTip() {
      this.showTip = false;
      // 重置变量
      this.tipMessage = "";
      this.tipNeedInput = false;
      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("cancel");
        this.tipResolver = null;
      }
    },
    confirmTip() {
      // this.showTip = false;
      // // 重置变量
      // this.tipMessage = "";
      // this.tipNeedInput = false;

      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("confirm");
        this.tipResolver = null;
      }
    },
    // 获取申请试用记录
    async clickShowApplyTestRecords() {
      // 如果已经是展开，直接返回
      if (this.showApplyTestRecords) {
        return;
      }
      await this.getApplyTestRecords();
      this.showApplyTestRecords = true;
    },
    cancelShowApplyTestRecords() {
      // 如果鼠标在展开的弹窗内，则直接返回，不关闭弹窗
      if (this.inApplyTestRecords) {
        return;
      }
      this.showApplyTestRecords = false;
    },
    async getApplyTestRecords() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/applet/getApplyTestRecord", params);
        if (resp1.data.code == "0000") {
          this.applyTestRecords = resp1.data.data;
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    }
  }
};